import axios from "axios";
import getSignHeaders from "@tcljs/utils/lib/sign";
const str = "xrsystem-o.api.leiniao.com";
let serviceBaseUrl = "";
const getUrl = () => {
  return location.hostname === "hwxrsystem-html-o.api.leiniao.com"
    ? `hwxrsystem-o.api.leiniao.com`
    : str;
};
if (!location.origin) {
  location.origin = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
}

process.env.NODE_ENV === "production"
  ? location.origin.includes("test")
    ? (serviceBaseUrl = "http://xr-t-api.test.leiniao.com")
    : (serviceBaseUrl = `${location.protocol}//${getUrl()}`)
  : (serviceBaseUrl = "/api");

const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: serviceBaseUrl, // url = base url + request url
  timeout: 5000, // request timeout
});
service.interceptors.request.use((options) => {
  const { method, url, data } = options;
  // console.log("options -- ", options);
  const opt = {
    method,
    url,
    data,
    params: options.params,
    appid: "xr-system-api", // appid
    app: "com.tcl.xrsystem", // app 可以与appid同一个值
    excludes: [],
  };
  let key;
  if (
    location.origin.includes("test") ||
    location.origin.includes("localhost")
  ) {
    key = "9J#qxiDyA75M@S*h$b.i^@8^aaFV8Jf*";
  } else {
    key = "9J#qxiDyA75M@S*h$b.i^@8^aaFV8Jf*";
  }
  const headers = getSignHeaders(opt, key); // key 是appid对应的秘钥，可以找后台拿
  // eslint-disable-next-line no-param-reassign
  options.headers = {
    ...options.headers,
    ...headers,
  };
  return options;
});
export default service;
